var _style, _polygon, _polygon2, _polyline, _polyline2, _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _polyline3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8F8F8;}\n\t.st1{fill:none;stroke:#B5B5B5;stroke-width:1.716;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#B5B5B5;stroke-width:1.7165;stroke-miterlimit:10;}\n\t.st3{fill:#B5B5B5;}\n\t.st4{fill:#E6F4FF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "No-Matching-results") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "121.3,102.1 109,72.4 109,54 109,54 132.4,102.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.7,102.1 39,72.4 39,54 39,54 15.6,102.1 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "39,54 39,72.4 109,72.4 109,54 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "132.4,102.1 109,54 39,54 15.6,102.1 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.2,102.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39,72.4l-12.3,29.7h23.1l0,0c0,7.4,6,13.3,13.3,13.3h21.7c7.4,0,13.3-6,13.3-13.3h23.1L109,72.4H39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.7,142.9h115c3.8,0,6.4-3.8,5.1-7.3l-12.4-33.5v28.1H14.6l5.3,9.9C20.9,141.8,22.7,142.9,24.7,142.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.2,102.1c0,7.4-6,13.3-13.3,13.3H63.1c-7.4,0-13.3-6-13.3-13.3l0,0H15.6v25c0,3.9,3.2,7.1,7.1,7.1h102.5 c3.9,0,7.1-3.2,7.1-7.1v-25H98.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.2,102.1c0,7.4-6,13.3-13.3,13.3H63.1c-7.4,0-13.3-6-13.3-13.3l0,0H15.6v28.1c0,2.3,1.8,4.1,4.1,4.1h108.6 c2.3,0,4.1-1.8,4.1-4.1v-28.1H98.2z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 74,
    y1: 15.4,
    x2: 74,
    y2: 32.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 35.5,
    y1: 28.1,
    x2: 47.3,
    y2: 39.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 112.9,
    y1: 28.1,
    x2: 101.1,
    y2: 39.9
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "39,54 39,72.4 109,72.4 109,54 "
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 109,
    y1: 72.4,
    x2: 121.3,
    y2: 102.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 39,
    y1: 72.4,
    x2: 26.7,
    y2: 102.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/No-results.fa74404e39566082fecee5e0f9552031.svg";
export { ForwardRef as ReactComponent };